


import {AuthRequestVM} from './AuthRequestVM';
export class ForgottenPasswordRequestVM extends AuthRequestVM {
    
    success?: boolean;
    
    message?: string;
    
}
